<!--
주문하기
------------------------------------
-->
<template>
    <!-- 모달 -->
    <div class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <div uk-height-viewport>

                <!-- 완료화면 -->
                <div v-show="jobState === 'done'" class="uk-flex uk-flex-center uk-flex-middle uk-height-large">
                    <div class="uk-text-large uk-text-center">
                        <div class="uk-margin-bottom">
                            <i class="material-icons md-36">done</i>
                            해외주문이 완료되었습니다.
                        </div>

                        <div class="">
                            <a
                                class="uk-button uk-button-primary uk-margin-right"
                                :href="orderPageUrl"
                            >
                                <span uk-icon="icon: plus-circle"></span>
                                계속 주문하기
                            </a>

                            <a
                                class="uk-button uk-button-white"
                                :href="listUrl"
                            >
                                <span uk-icon="icon: forward"></span>
                                주문내역 확인하기
                            </a>
                        </div>
                    </div>
                </div>


                <!-- 작성화면 -->
                <div v-show="jobState === 'input'">
                    <div class="uk-flex uk-flex-between header-bar">
                        <div class="uk-width-expand uk-flex uk-flex-center uk-flex-wrap">
                        <span
                            class="mall"
                            v-for="(mall, key) in venderMalls"
                            :key="key"
                        >
                            {{ mall }}
                        </span>
                        </div>

                        <!-- 닫기 -->
                        <button type="button" uk-close @click="close"></button>
                    </div>


                    <!-- 주문상품 -->
                    <prods
                        class="uk-margin-bottom"
                        :job-targets="jobTargets"
                        :region-currency="regionCurrency"
                        :total-buy-price="totalBuyPrice"
                    >
                    </prods>

                    <!-- 주문정보작성 -->
                    <inputs
                        class=""

                        :region-currency="regionCurrency"

                        :region-id="regionId"
                        :agent-id="agentId"
                        :user-id="userId"

                        :order="order"
                        :shipping-center-options="shippingCenterOptions"
                        :payment-method-options="paymentMethodOptions"
                    >
                    </inputs>


                    <div class="uk-text-center uk-padding">
                        <!-- 취소 버튼 -->
                        <button
                            class="uk-button uk-button-gray uk-margin-right"
                            @click="close"
                        >
                            <i class="material-icons">close</i>
                            취소
                        </button>

                        <!-- 완료 버튼 -->
                        <button
                            class="uk-button uk-button-primary"
                            @click="submit"
                        >
                            <i class="material-icons">check</i>
                            작성완료
                        </button>
                    </div>
                </div>




            </div>
        </div>
    </div>


</template>

<script>
    export default {
        components: {
            'prods': require('./prods.vue').default,
            'inputs': require('./inputs.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // 지역화폐
            regionCurrency: String,

            // 지역ID
            regionId: Number,

            // 영업소ID
            agentId: Number,

            // 사용자ID
            userId: Number,
        },
        data: function () {
            
            return {
                /**
                 * 현재 작업진행상태
                 *  - input : 작성중
                 *  - done : 완료
                 */
                jobState: 'input',

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],

                /**
                 * 선택한 상품들의 해외쇼핑몰 배열
                 */
                venderMalls: [],

                /**
                 * (object) 오더정보
                 */
                order: {},

                /**
                 * (array) 배송지 옵션
                 */
                shippingCenterOptions: [],

                /**
                 * (array) payment_method 옵션
                 */
                paymentMethodOptions: [],
            };
        },

        mounted: function () {
            // 옵션정보 조회하기
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/regions/'+this.regionId+'/agents/'+this.agentId+'/users/'+this.userId+'/init-to-buy-order',
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            load.then((response) => {
                // 옵션정보 저장
                this.shippingCenterOptions = response.shipping_center_options;
                this.paymentMethodOptions = response.payment_method_options;
                //this.regionCurrency = response.region_currency;

                // 배송지 선택안함 옵션 추가
                this.shippingCenterOptions.unshift({
                    text: '선택안함',
                    val: '',
                });


            });

        },

        computed: {
            /**
             * 계속주문하기 페이지
             * @returns {string}
             */
            orderPageUrl() {
                return '/regions/'+ this.regionId +'/agents/'+ this.agentId +'/users/'+ this.userId +'/prods-to-order';
            },

            /**
             * 주문내역 확인하기 페이지
             * @returns {string}
             */
            listUrl() {
                return '/regions/'+ this.regionId +'/agents/'+ this.agentId +'/users/'+ this.userId +'/buy-orders';
            },

            /**
             * 총 구매금액
             * @return number
             */
            totalBuyPrice() {
                let total = 0;
                _.each(this.jobTargets, (target) => {
                    let price = target.inputBuyUnitPrice;

                    if (isNaN(price)) {
                        return;
                    }

                    // 구입단가 * 수량
                    total += parseFloat(price) * parseInt(target.prod.amount);
                });

                return _.round(total, 2);
            },
        },
        methods: {

            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 진행상태
                this.jobState='input';


                // 작업대상아이템 배열작성
                this.venderMalls = [];
                this.jobTargets = _.map(this.batch.checked_items, item => {
                    // 해외쇼핑몰 작성
                    if (item.vender_mall) {
                        if (_.findIndex(this.venderMalls, mall => { return mall === item.vender_mall}) === -1) {
                            this.venderMalls.push(item.vender_mall);
                        }
                    }


                    // 작업대상 생성
                    return {
                        prod: item,
                        inputHpOrderUnitPriceKrw: item.hp_order_unit_price_krw, // 원화판매가 입력값
                        inputUnitPrice: item.unit_price, // 단가 입력값
                        inputBuyUnitPrice: item.buy_unit_price, // 구매단가 입력값
                    };
                });

                // 주문정보 입력값 초기화
                this.order = {
                    buy_order_code: null,
                    order_date: moment().format('YYYY-MM-DD'), // 오늘날짜
                    order_url: null,
                    order_email: null,
                    order_id: null,

                    shipping_center: '',

                    payment_method: null,
                    payment_memo: null,
                    payment_price: this.totalBuyPrice,
                };

                // 해외쇼핑몰이 1개면 주문URL로 자동입력
                if (this.venderMalls.length === 1) {
                    this.order.order_url = this.venderMalls[0];
                }

                // 모달창
                UIkit.modal(this.$el).show();
            },

            // 모달 창 닫기
            close() {
                UIkit.modal(this.$el).hide();
            },

            /**
             * submit
             */
            submit() {

                // 상품정보 json 처리
                let prods = {};
                _.each(this.jobTargets, (target) => {
                    prods[target.prod.id] = {
                        hp_order_unit_price_krw: target.inputHpOrderUnitPriceKrw,
                        unit_price: target.inputUnitPrice,
                        buy_unit_price: target.inputBuyUnitPrice,
                    };
                });
                prods = JSON.stringify(prods);

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/buy-orders/store-with-prods',
                    data: _.merge({
                        '_token': this.csrfToken,

                        'region_id': this.regionId,
                        'agent_id': this.agentId,
                        'user_id': this.userId,

                        'prods': prods,
                    }, this.order),

                    success: (response, textStatus, jqXHR) => {
                        this.jobState = 'done';
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },


        }
    }
</script>

<style lang="scss" scoped>
    .header-bar {
        padding-top: 1rem;
        padding-right: 1rem;

        .mall {
            display: inline-block;
            padding: 0 1rem;
            border: 1px solid #666;
            background-color: #fff;
            color: #000;

            line-height: 1.5;
            font-size: 1.25rem;

            vertical-align: middle;
            white-space: nowrap;
            border-radius: 4px;
            text-transform: uppercase;

            margin-right: 1rem;
        }
    }
</style>